import { useEffect } from 'react'
import { useTheme } from '@/contexts/SettingsContext.tsx'
import { DialogCloseButton } from '../../ui/DialogCloseButton'
import { getColorPresets } from './Dialog.constants'
import './color-picker-dialog.css'

interface ColorPickerDialogProps {
	currentColor: string
	onColorChange: (_color: string) => void
	onClose: () => void
	position?: {
		left?: string
		top?: string
	}
	useRelativePosition?: boolean
}

export function ColorPickerDialog({
									  currentColor,
									  onColorChange,
									  onClose,
									  useRelativePosition = false,
								  }: ColorPickerDialogProps) {
	const { theme } = useTheme()
	const colorPresets = getColorPresets(theme)

	// Set default color based on theme if no color is set
	useEffect(() => {
		if (!currentColor || currentColor === '') {
			const foregroundColor = getComputedStyle(document.documentElement).getPropertyValue('--foreground').trim()
			onColorChange(foregroundColor || '#FFFFFF')
		}
	}, [currentColor, onColorChange]) // Only run when dependencies change

	return (
		<div
			data-color-dialog
			className="color-picker-dialog"
			data-positioned={!useRelativePosition}>
			<div className="color-picker-dialog-header">
				<span className="color-picker-dialog-title">Pick Color</span>
				<DialogCloseButton onClose={onClose} />
			</div>

			{/* Custom Color Input */}
			<div className="color-picker-dialog-section">
				<label className="color-picker-dialog-label">
					Custom Color
				</label>
				<div className="color-picker-dialog-custom">
					<input
						type="color"
						value={currentColor}
						onChange={(e) => onColorChange(e.target.value)}
						className="color-picker-dialog-color-input"
					/>
					<input
						type="text"
						value={currentColor}
						onChange={(e) => onColorChange(e.target.value)}
						className="color-picker-dialog-text-input"
						placeholder="#FFFFFF"
					/>
				</div>
			</div>

			{/* Preset Colors */}
			<div className="color-picker-dialog-section">
				<label className="color-picker-dialog-label">
					Presets
				</label>
				<div className="color-picker-dialog-preset-grid">
					{colorPresets.map((preset) => (
						<button
							key={preset.value}
							onClick={() => onColorChange(preset.value)}
							className="color-picker-dialog-preset-button"
							data-selected={currentColor === preset.value}
							style={{ backgroundColor: preset.value }}
							title={preset.name}
						/>
					))}
				</div>
			</div>
		</div>
	)
}